import { getAuth } from "firebase/auth";

import { getAPIURLv2, xget } from "../Fetchv2.js";

export namespace DigeducaChat {
	export interface ContentPart {
		text?: string;
		functionCall?: { name: string; args: Record<string, unknown> };
		functionResponse?: { name: string; response: unknown };
	}

	export interface Content {
		role: string;
		parts: ContentPart[];
	}

	export interface RequestBody {
		audience?: string;
		userMessage?: string;
		toolResponseParts?: ContentPart[];
		contents?: Content[];
	}

	export type Event =
		| { type: "text"; text: string }
		| { type: "function_calls"; calls: Array<{ name: string; args: Record<string, unknown> }>; assistantContent?: Content }
		| { type: "done" }
		| { type: "error"; message: string };

	export interface FaqItem {
		id: number;
		category: string;
		q: string;
		a: string;
		keywords?: string[];
		score?: number;
	}

	export interface SuggestedFaq {
		id: number;
		q: string;
		category: string;
	}
}

export class DigeducaAi {
	async chat(body: DigeducaChat.RequestBody, onEvent: (event: DigeducaChat.Event) => void, signal?: AbortSignal): Promise<void> {
		const idToken = (await getAuth().currentUser?.getIdToken()) || "no-auth";
		const url = getAPIURLv2() + "/digeduca/ai/chat";

		const response = await fetch(url, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Authorization: `bearer ${idToken}`,
				"Cache-Control": "no-cache"
			},
			body: JSON.stringify(body),
			signal
		});

		if (!response.ok || !response.body) {
			onEvent({ type: "error", message: `HTTP ${response.status}` });
			return;
		}

		const reader = response.body.getReader();
		const decoder = new TextDecoder();
		let buffer = "";

		while (true) {
			const { done, value } = await reader.read();
			if (done) break;
			buffer += decoder.decode(value, { stream: true });

			const lines = buffer.split("\n\n");
			buffer = lines.pop() ?? "";

			for (const line of lines) {
				if (!line.startsWith("data: ")) continue;
				try {
					const event = JSON.parse(line.slice(6)) as DigeducaChat.Event;
					onEvent(event);
				} catch {
					// skip malformed chunk
				}
			}
		}

		if (buffer.startsWith("data: ")) {
			try {
				const event = JSON.parse(buffer.slice(6)) as DigeducaChat.Event;
				onEvent(event);
			} catch {
				// skip
			}
		}
	}

	suggestedFaqs(audience?: string, limit = 6) {
		return xget<{ items: DigeducaChat.SuggestedFaq[] }>("/digeduca/ai/faqs/suggested", { audience, limit });
	}
}
